export const CONSTANTS = {
  features: [
    {
      text: "Custom-built network architectures optimized for performance and scalability.",
    },
    {
      text: "Seamless deployment of wired, wireless, and cloud-based infrastructure.",
    },
    {
      text: "Advanced security protocols and compliance adherence.",
    },
    {
      text: "AI-driven network monitoring and performance enhancements.",
    },
  ],
  title: "Why choose OneMind Services for Design and Deployment?",
  description: [
    "OneMind Services delivers comprehensive network design and deployment solutions for enterprises, data centers, and cloud environments. Our expert engineers ensure:",
  ],
  extraContent:
    "With OneMind Services, businesses gain a future-ready IT infrastructure that supports innovation, efficiency, and security.",
};
